import { Routes } from '@angular/router';

export const creditRequestRoutes: Routes = [
  {
    path: 'start',
    loadComponent: () =>
      import('./pages/start/start.component').then((m) => m.StartComponent),
  },
  {
    path: 'credit-offer',
    loadComponent: () =>
      import('./pages/credit-offer/credit-offer.component').then(
        (m) => m.CreditOfferComponent,
      ),
  },
  {
    path: 'verify-code',
    loadComponent: () =>
      import('./pages/verify-code/verify-code.component').then((m) => m.VerifyCodeComponent),
  },
  {
    path: 'personal-data',
    loadComponent: () =>
      import('./pages/personal-data/personal-data.component').then((m) => m.PersonalDataComponent),
  },
  {
    path: 'confirmation',
    loadComponent: () =>
      import('./pages/confirmation/confirmation.component').then((m) => m.ConfirmationComponent),
  },
  {
    path: 'result',
    loadComponent: () =>
      import('./pages/result/result.component').then((m) => m.ResultComponent),
  },
  { path: '', redirectTo: 'start', pathMatch: 'full' },
];
